var checkFullWidthNumberOrder = function (order) {
    if (typeof order === "number" && order > 0) {
        return "order: ".concat(order, ";");
    }
    return null;
};
export default checkFullWidthNumberOrder;
